import {
    AfterViewInit,
    Component,
    ElementRef,
    NgZone,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromAuth from '../../auth/store/auth.reducer';
import { IUserInfo, getUserInfo } from '../../user-info';
import { CompanyInfo, Purchase } from '../../customer-admin/customer-admin.model';
import { CustomerAdminService } from '../../customer-admin/customer-admin.service';
import { GroupsService } from '../../groups/groups.service';
import { IGroupMember } from '../../groups/IGroups';
import { AuthorizenetCheckoutService } from '../authorizenet-checkout.service';
import { AuthorizeNetCustomerProfileResponse } from '../IAuthorizeNetSubscriptions';

@Component({
    selector: 'ef-authorizenet-checkout-presenter',
    templateUrl: './authorizenet-checkout-presenter.component.html',
    styleUrls: ['./authorizenet-checkout-presenter.component.scss'],
    standalone: false
})
export class AuthorizenetCheckoutPresenterComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    readonly additionalAdminProductName = 'Additional Admin';
    readonly rightworksAccessProductName = 'RightWorks Access';
    readonly additionalAdminUnitPrice = 31;
    readonly rightworksAccessUnitPrice = 75;
    /** Mirrors Web.config additionalAdminProductId / shopifySubscriptionSkuBilling sku "200". */
    readonly additionalAdminProductId = 200;
    /** Mirrors Web.config additionalAdminAnnualProductId / shopifySubscriptionSkuBilling sku "201". */
    readonly additionalAdminAnnualProductId = 201;
    readonly additionalAdminBillingPeriod: 'Monthly' | 'Annual' = 'Monthly';
    readonly additionalAdminAnnualBillingPeriod: 'Monthly' | 'Annual' = 'Annual';
    /** Mirrors Web.config rightworksAccessProductId / shopifySubscriptionSkuBilling sku "210". */
    readonly rightworksAccessProductId = 210;
    readonly rightworksAccessSku = '210';
    readonly rightworksAccessBillingPeriod: 'Monthly' | 'Annual' = 'Monthly';
    /** Host provider that supports optional cloud-login email on admin license changes. */
    readonly cloudLoginHostProviderId = 1015;
    readonly acceptUiApiLoginId = environment.authorizeNet.apiLoginId;
    readonly acceptUiClientKey = environment.authorizeNet.clientKey;

    layout = 'list';
    products: Product[];
    layoutOptions: any[];
    selectedLayout: any;
    quantity = '0';
    showCart = false;
    selectedProduct: Product;
    selectedProducts: Product[];
    public uri;
    paymentFormId: string;

    transactionResponse: string;

    licensedAdminCount = 1;
    assignedAdminCount = 0;
    advisorAdminCount = 0;
    assignedAdvisorAdminCount = 0;
    targetLicensedAdminCount = 1;
    /** Cloud login email for the administrator license being added or canceled (eFAACT Store UI). */
    emailForCloudLogin = '';
    /** Required in dialog when the logged-in user has no usable EmailAddr on file. */
    companyEmailAddrInput = '';
    showCloudLoginOption = false;
    cloudLoginChecked = false;
    loadingAdminInfo = true;
    companyInfoLoadFailed = false;
    readonly companyInfoUnavailableMessage =
        'We were unable to load your company billing profile, which is required to complete purchases in eFAACT Central. Administrator license changes are unavailable at this time. Please refresh the page or contact eFAACT support if this issue continues.';
    readonly adminRemovalHelpdeskMessage =
        'For accounts not billed via credit card, please contact the eFAACT Helpdesk to request administrator removal.';
    adminLicensePreviewMessage: string | null = null;

    showAdminLicenseConfirmDialog = false;
    showAdminLicenseRemovalConfirm = false;
    showAdminLicenseTypeChoice = false;
    showAdminRemovalHelpdeskDialog = false;
    /** Chosen billing cadence to cancel: 'A' = annual, 'M' = monthly, null = no annual on file. */
    adminLicenseRemovalType: 'A' | 'M' | null = null;
    adminLicenseDialogMode: 'add' | 'remove' = 'add';
    adminLicenseConfirmLoading = false;
    adminLicenseConfirmError: string | null = null;
    paymentMethodOnFileDisplay: string | null = null;
    loadingPaymentMethodOnFile = false;

    @ViewChild('adminAcceptUiTrigger')
    adminAcceptUiTrigger?: ElementRef<HTMLButtonElement>;

    private customerId: string | null = null;
    private customerProfileId: string | null = null;
    private companyInfo: CompanyInfo | null = null;
    private userEmailAddr: string | null = null;
    private active = true;
    private adminLicensePaymentInFlight = false;
    private skipAdminLicenseDialogResetOnHide = false;
    private paymentMethodRefreshGeneration = 0;

    constructor(
        private store: Store,
        private customerAdminService: CustomerAdminService,
        private groupsService: GroupsService,
        private authorizeNetCheckoutService: AuthorizenetCheckoutService,
        private ngZone: NgZone
    ) {
        this.uri = `${environment.apiLocation}/AuthorizeNet`;
        this.layoutOptions = [
            {
                icon: 'pi pi-table bg-white text-gray-600',
                label: '',
                value: 'grid'
            },
            {
                icon: 'pi pi-list bg-white text-gray-600',
                label: '',
                value: 'list'
            }
        ];
        this.selectedLayout = this.layoutOptions[1];
        this.products = [
            {
                name: 'eFAACT Private Webinar',
                category: 'Training',
                price: '0.01',
                image: '../../../images/eFAACTProductImage.jpg',
                quantity: '1',
                id: '1'
            },
            /*{
                name: 'Additional Admin',
                category: 'eFAACT for QBO',
                price: '0.01',
                image: '../../../images/eFAACTProductImage.jpg',
                quantity: '1',
                id: '2'
            },
            {
                name: 'Additional Admin',
                category: 'eFAACT for QBD',
                price: '0.01',
                image: '../../../images/eFAACTProductImage.jpg',
                quantity: '1',
                id: '3'
            },
            {
                name: 'Additional Admin',
                category: 'eFAACT Cloud',
                price: '0.01',
                image: '../../../images/eFAACTCloudProductImage.jpg',
                quantity: '1',
                id: '4'
            },
            {
                name: 'Additional Admin',
                category: 'eFAACT Elite Cloud',
                price: '0.01',
                image: '../../../images/eFAACTEliteCloudProductImage.jpg',
                quantity: '1',
                id: '5'
            }*/
        ];
        this.selectedProduct = this.products[0];
        this.selectedProducts = [];
    }

    ngOnInit(): void {
        this.registerAdminLicenseAcceptUiHandler();
        this.loadUserEmailAddr();
        this.loadAdministratorInfo();
    }

    ngAfterViewInit() {
        this.loadAcceptUiScript();
        const url = window.location.href;
        const spliturl = url.split('#');
        this.transactionResponse = spliturl[spliturl.length - 1];
        while (this.transactionResponse.includes('%20') == true) {
            this.transactionResponse = this.transactionResponse.replace(
                '%20',
                ' '
            );
        }
    }

    ngOnDestroy() {
        this.active = false;
        this.selectedProduct = null;
        this.selectedProducts = [];
        delete (window as { __efAdminLicenseAcceptUiCallback?: unknown })
            .__efAdminLicenseAcceptUiCallback;
    }

    public get canModifyAdminLicenses(): boolean {
        return !this.loadingAdminInfo && !this.companyInfoLoadFailed;
    }

    public get availableAdminSlots(): number {
        return Math.max(0, this.licensedAdminCount - this.assignedAdminCount);
    }

    public get licenseChangeDelta(): number {
        return this.targetLicensedAdminCount - this.licensedAdminCount;
    }

    public get canDecrementTargetAdminCount(): boolean {
        return (
            this.targetLicensedAdminCount > this.assignedAdminCount &&
            this.targetLicensedAdminCount > 1
        );
    }

    /** Non–credit-card customers with more than one licensed admin cannot self-serve removal. */
    public get requiresHelpdeskForAdminRemoval(): boolean {
        return this.licensedAdminCount > 1 && !this.customerProfileId;
    }

    public get licenseChangeSummary(): string | null {
        const delta = this.licenseChangeDelta;
        if (delta === 0) {
            return null;
        }
        const action = delta > 0 ? 'add' : 'remove';
        const count = Math.abs(delta);
        return `This will ${action} ${count} administrator license${count === 1 ? '' : 's'}.`;
    }

    public get adminLicenseOrderQuantity(): number {
        return Math.max(0, this.licenseChangeDelta);
    }

    public get adminLicenseOrderTotal(): number {
        return this.adminLicenseOrderQuantity * this.additionalAdminUnitPrice;
    }

    public get adminLicenseRemovalQuantity(): number {
        return Math.max(0, -this.licenseChangeDelta);
    }

    public get adminLicenseRemovalTotal(): number {
        return this.adminLicenseRemovalQuantity * this.additionalAdminUnitPrice;
    }

    public get adminLicenseDialogHeader(): string {
        return this.adminLicenseDialogMode === 'add'
            ? 'Confirm administrator license purchase'
            : 'Cancel administrator subscription';
    }

    public get adminLicenseDialogQuantity(): number {
        return this.adminLicenseDialogMode === 'add'
            ? this.adminLicenseOrderQuantity
            : this.adminLicenseRemovalQuantity;
    }

    public get adminLicenseDialogTotal(): number {
        return this.adminLicenseDialogQuantity * this.additionalAdminUnitPrice;
    }

    public get rightworksAccessOrderQuantity(): number {
        if (
            !this.showCloudLoginOption ||
            !this.cloudLoginChecked ||
            this.licenseChangeDelta <= 0
        ) {
            return 0;
        }

        return this.adminLicenseOrderQuantity;
    }

    public get rightworksAccessOrderTotal(): number {
        return this.rightworksAccessOrderQuantity * this.rightworksAccessUnitPrice;
    }

    public get rightworksAccessDialogQuantity(): number {
        if (
            !this.showCloudLoginOption ||
            !this.cloudLoginChecked ||
            this.adminLicenseDialogMode !== 'add'
        ) {
            return 0;
        }

        return this.adminLicenseDialogQuantity;
    }

    public get rightworksAccessDialogTotal(): number {
        return this.rightworksAccessDialogQuantity * this.rightworksAccessUnitPrice;
    }

    public get adminLicenseDialogCombinedTotal(): number {
        return this.adminLicenseDialogTotal + this.rightworksAccessDialogTotal;
    }

    private shouldIncludeRightworksAccess(): boolean {
        return (
            this.showCloudLoginOption &&
            this.cloudLoginChecked &&
            this.adminLicenseDialogMode === 'add'
        );
    }

    public get needsAdminLicensePaymentSetup(): boolean {
        return !this.customerProfileId;
    }

    public get adminLicensePaymentSetupInfoText(): string {
        return (
            'Credit card payments are securely processed and tokenized by Authorize.Net, our PCI-compliant payment processor. ' +
            'Card details are entered in Authorize.Net\'s secure payment form and transmitted directly to Authorize.Net. ' +
            'At no point is your credit card data stored by or shared with eFAACT.'
        );
    }

    public get paymentMethodOnFileMessageText(): string {
        if (this.loadingPaymentMethodOnFile) {
            return 'Loading your payment method on file from Authorize.Net...';
        }

        if (this.paymentMethodOnFileDisplay) {
            return (
                `This purchase will be billed to ${this.paymentMethodOnFileDisplay} on file with Authorize.Net, our PCI-compliant payment processor. ` +
                'Your card is stored only as a tokenized payment profile at Authorize.Net, not in eFAACT.' +
                'By confirming, you authorize Authorize.Net to charge that payment method and create the subscription(s) shown above.'
            );
        }

        return (
            'This purchase will be billed using your payment method on file with Authorize.Net, our PCI-compliant payment processor. ' +
            'Your card is stored only as a tokenized payment profile at Authorize.Net, not in eFAACT. ' +
            'By confirming, you authorize Authorize.Net to charge that payment profile and create the subscription(s) shown above.'
        );
    }

    public get hasCompanyBillingAddress(): boolean {
        const info = this.companyInfo;
        return !!(
            info?.Address1?.trim() &&
            info?.City?.trim() &&
            info?.State?.trim() &&
            info?.ZipCode?.trim()
        );
    }

    incrementTargetAdminCount(): void {
        this.targetLicensedAdminCount++;
        this.adminLicensePreviewMessage = null;
    }

    decrementTargetAdminCount(): void {
        if (!this.canDecrementTargetAdminCount) {
            return;
        }
        if (this.requiresHelpdeskForAdminRemoval) {
            this.showAdminRemovalHelpdeskDialog = true;
            return;
        }
        this.targetLicensedAdminCount--;
        this.adminLicensePreviewMessage = null;
    }

    dismissAdminRemovalHelpdeskDialog(): void {
        this.showAdminRemovalHelpdeskDialog = false;
    }

    applyLicenseChangePreview(): void {
        if (!this.canModifyAdminLicenses) {
            return;
        }

        if (this.licenseChangeDelta === 0) {
            return;
        }

        if (this.licenseChangeDelta > 0) {
            this.adminLicenseDialogMode = 'add';
            this.openAdminLicenseConfirmDialog();
            return;
        }

        if (!this.customerProfileId) {
            if (this.requiresHelpdeskForAdminRemoval) {
                this.showAdminRemovalHelpdeskDialog = true;
            } else {
                this.adminLicensePreviewMessage =
                    'Unable to remove administrator licenses until billing has been set up for this account.';
            }
            return;
        }

        this.adminLicenseDialogMode = 'remove';
        this.openAdminLicenseConfirmDialog();
    }

    private openAdminLicenseConfirmDialog(): void {
        this.adminLicenseConfirmError = null;
        this.adminLicenseConfirmLoading = false;
        this.adminLicensePaymentInFlight = false;
        this.resetCloudLoginDialogState();
        this.paymentMethodOnFileDisplay = null;
        this.loadingPaymentMethodOnFile =
            !this.needsAdminLicensePaymentSetup && !!this.customerProfileId;
        this.paymentMethodRefreshGeneration++;
        const refreshGeneration = this.paymentMethodRefreshGeneration;
        this.showAdminLicenseConfirmDialog = true;
        void this.refreshPaymentMethodOnFileForDialog(refreshGeneration);
    }

    onAdminLicenseConfirmDialogHide(): void {
        if (this.adminLicenseConfirmLoading) {
            return;
        }

        if (this.skipAdminLicenseDialogResetOnHide) {
            this.skipAdminLicenseDialogResetOnHide = false;
            return;
        }

        this.dismissAdminLicenseConfirmDialog(true);
    }

    cancelAdminLicenseChange(): void {
        this.skipAdminLicenseDialogResetOnHide = true;
        this.dismissAdminLicenseConfirmDialog(true);
    }

    private closeAdminLicenseConfirmDialogAfterSuccess(): void {
        this.skipAdminLicenseDialogResetOnHide = true;
        this.clearAdminLicenseDialogTransientState();
        this.showAdminLicenseConfirmDialog = false;
    }

    private dismissAdminLicenseConfirmDialog(resetLicenseChange: boolean): void {
        this.showAdminLicenseConfirmDialog = false;
        this.clearAdminLicenseDialogTransientState();

        if (resetLicenseChange) {
            this.targetLicensedAdminCount = this.licensedAdminCount;
            this.adminLicensePreviewMessage = null;
        }
    }

    private clearAdminLicenseDialogTransientState(): void {
        this.adminLicenseConfirmError = null;
        this.adminLicenseConfirmLoading = false;
        this.showAdminLicenseRemovalConfirm = false;
        this.showAdminLicenseTypeChoice = false;
        this.adminLicenseRemovalType = null;
        this.adminLicensePaymentInFlight = false;
        this.paymentMethodRefreshGeneration++;
        this.resetCloudLoginDialogState();
        this.clearPaymentMethodOnFileDisplay();
    }

    public get requiresCompanyEmailInput(): boolean {
        return !this.isUsableUserEmail(this.userEmailAddr);
    }

    onCloudLoginCheckedChange(checked: boolean): void {
        if (!checked) {
            this.emailForCloudLogin = '';
        }
        if (this.adminLicenseConfirmError === 'Enter an email for RightWorks Access.') {
            this.adminLicenseConfirmError = null;
        }
    }

    private clearPaymentMethodOnFileDisplay(): void {
        this.paymentMethodOnFileDisplay = null;
        this.loadingPaymentMethodOnFile = false;
    }

    private resetCloudLoginDialogState(): void {
        this.cloudLoginChecked = false;
        this.emailForCloudLogin = '';
        this.companyEmailAddrInput = '';
    }

    private loadUserEmailAddr(): void {
        this.store
            .pipe(
                select(getUserInfo),
                filter((userInfo): userInfo is IUserInfo => !!userInfo),
                take(1),
                takeWhile(() => this.active)
            )
            .subscribe(userInfo => {
                this.userEmailAddr = userInfo.EmailAddr ?? null;
            });
    }

    private isUsableUserEmail(email: string | null | undefined): boolean {
        const trimmed = email?.trim();
        if (!trimmed) {
            return false;
        }

        return trimmed.toLowerCase() !== 'na';
    }

    private validateAdminLicenseDialogInput(): boolean {
        if (!this.validateCompanyEmailAddrInput()) {
            return false;
        }

        return this.validateCloudLoginInput();
    }

    private validateCompanyEmailAddrInput(): boolean {
        if (this.getCompanyEmailAddrToPersist()) {
            if (this.adminLicenseConfirmError === 'Enter an email address.') {
                this.adminLicenseConfirmError = null;
            }
            return true;
        }

        this.adminLicenseConfirmError = 'Enter an email address.';
        return false;
    }

    private getCompanyEmailAddrToPersist(): string | undefined {
        if (this.isUsableUserEmail(this.userEmailAddr)) {
            return this.userEmailAddr!.trim();
        }

        const trimmed = this.companyEmailAddrInput?.trim();
        return trimmed || undefined;
    }

    private validateCloudLoginInput(): boolean {
        if (!this.showCloudLoginOption || !this.cloudLoginChecked) {
            return true;
        }

        if (!this.emailForCloudLogin?.trim()) {
            this.adminLicenseConfirmError = 'Enter an email for RightWorks Access.';
            return false;
        }

        return true;
    }

    private getEmailForCloudLoginToPersist(): string | undefined {
        if (!this.showCloudLoginOption || !this.cloudLoginChecked) {
            return undefined;
        }

        const trimmed = this.emailForCloudLogin?.trim();
        return trimmed || undefined;
    }

    openAdminLicensePayment(): void {
        this.adminLicenseConfirmError = null;

        if (this.adminLicensePaymentInFlight || this.adminLicenseConfirmLoading) {
            return;
        }

        if (!this.validateAdminLicenseDialogInput()) {
            return;
        }

        if (!this.hasCompanyBillingAddress) {
            this.adminLicenseConfirmError =
                'Company address is incomplete. Complete Address, City, State, and Zip on company info (used when payment billing fields are left blank).';
            return;
        }

        if (!this.customerId) {
            this.adminLicenseConfirmError =
                'Customer ID is not available. Sign in again and retry.';
            return;
        }

        if (this.adminLicenseOrderQuantity <= 0) {
            this.adminLicenseConfirmError =
                'No administrator licenses selected to purchase.';
            return;
        }

        const trigger = this.adminAcceptUiTrigger?.nativeElement;
        if (!trigger) {
            this.adminLicenseConfirmError =
                'Payment form is not ready. Refresh the page and try again.';
            return;
        }

        trigger.click();
    }

    async confirmAdminLicenseChange(): Promise<void> {
        if (this.adminLicenseDialogMode === 'remove') {
            await this.confirmAdminLicenseRemoval();
            return;
        }

        if (!this.validateAdminLicenseDialogInput()) {
            return;
        }

        const quantity = this.adminLicenseOrderQuantity;
        if (quantity <= 0) {
            return;
        }

        this.adminLicenseConfirmLoading = true;
        this.adminLicenseConfirmError = null;

        try {
            const profileIds = await this.loadCustomerProfileIds();
            const adminSubscriptionIds: string[] = [];
            const rightworksSubscriptionIds: string[] = [];

            for (let index = 0; index < quantity; index++) {
                const subscriptionName = this.buildProductSubscriptionName(
                    this.additionalAdminProductName,
                    index
                );

                const response = await this.authorizeNetCheckoutService
                    .createSubscriptionFromCustomerProfile({
                        ...profileIds,
                        subscriptionName,
                        amount: this.additionalAdminUnitPrice,
                        startDate: this.getSubscriptionStartDate(),
                        intervalLength: 1,
                        intervalUnit: 'months',
                        totalOccurrences: 9999
                    })
                    .pipe(take(1))
                    .toPromise();

                if (response?.subscriptionId == null) {
                    throw new Error('Authorize.Net did not return a subscription ID.');
                }

                adminSubscriptionIds.push(String(response.subscriptionId));
            }

            if (this.shouldIncludeRightworksAccess()) {
                const rightworksQuantity = this.rightworksAccessOrderQuantity;
                for (let index = 0; index < rightworksQuantity; index++) {
                    const subscriptionName = this.buildProductSubscriptionName(
                        this.rightworksAccessProductName,
                        index
                    );

                    const response = await this.authorizeNetCheckoutService
                        .createSubscriptionFromCustomerProfile({
                            ...profileIds,
                            subscriptionName,
                            amount: this.rightworksAccessUnitPrice,
                            startDate: this.getSubscriptionStartDate(),
                            intervalLength: 1,
                            intervalUnit: 'months',
                            totalOccurrences: 9999
                        })
                        .pipe(take(1))
                        .toPromise();

                    if (response?.subscriptionId == null) {
                        throw new Error(
                            'Authorize.Net did not return a RightWorks Access subscription ID.'
                        );
                    }

                    rightworksSubscriptionIds.push(String(response.subscriptionId));
                }
            }

            if (this.customerId) {
                try {
                    const persistResponse = await this.authorizeNetCheckoutService
                        .recordAdminLicensePurchase(
                            this.customerId,
                            quantity,
                            adminSubscriptionIds,
                            this.getCompanyEmailAddrToPersist(),
                            this.getEmailForCloudLoginToPersist(),
                            rightworksSubscriptionIds
                        )
                        .pipe(take(1))
                        .toPromise();
                    this.applyPersistedCompanyInfoLicenseUpdates({
                        adminCount: persistResponse?.adminCount,
                        activePurchaseCount: persistResponse?.activePurchaseCount,
                        subscriptionId:
                            persistResponse?.subscriptionId ?? adminSubscriptionIds[0],
                        subscriptionIds: adminSubscriptionIds,
                        rightworksSubscriptionIds,
                        emailForCloudLogin: this.getEmailForCloudLoginToPersist()
                    });
                } catch {
                    // Subscriptions were created; company info persistence is best-effort.
                }
            }

            this.licensedAdminCount = this.targetLicensedAdminCount;
            const totalSubscriptionsCreated =
                adminSubscriptionIds.length + rightworksSubscriptionIds.length;
            this.adminLicensePreviewMessage =
                `Created ${totalSubscriptionsCreated} subscription${totalSubscriptionsCreated === 1 ? '' : 's'}` +
                (rightworksSubscriptionIds.length > 0
                    ? ` (${adminSubscriptionIds.length} administrator and ${rightworksSubscriptionIds.length} RightWorks Access).`
                    : ` (${adminSubscriptionIds.length} administrator).`);
            this.closeAdminLicenseConfirmDialogAfterSuccess();
        } catch (err) {
            this.adminLicenseConfirmError = this.getAuthorizeNetErrorMessage(err);
        } finally {
            this.adminLicenseConfirmLoading = false;
        }
    }

    startAdminLicenseRemoval(): void {
        if (this.adminLicenseConfirmLoading) {
            return;
        }
        this.adminLicenseConfirmError = null;
        this.adminLicenseRemovalType = null;

        if (this.hasAnnualAdminSubscriptions) {
            this.showAdminLicenseTypeChoice = true;
            return;
        }

        this.showAdminLicenseRemovalConfirm = true;
    }

    selectAdminLicenseRemovalType(type: 'A' | 'M'): void {
        if (this.adminLicenseConfirmLoading) {
            return;
        }
        this.adminLicenseRemovalType = type;
        this.showAdminLicenseTypeChoice = false;
        this.showAdminLicenseRemovalConfirm = true;
    }

    dismissAdminLicenseTypeChoice(): void {
        if (this.adminLicenseConfirmLoading) {
            return;
        }
        this.showAdminLicenseTypeChoice = false;
        this.adminLicenseRemovalType = null;
    }

    dismissAdminLicenseRemovalConfirmation(): void {
        if (this.adminLicenseConfirmLoading) {
            return;
        }
        this.showAdminLicenseRemovalConfirm = false;
    }

    async confirmAdminLicenseRemovalConfirmed(): Promise<void> {
        await this.confirmAdminLicenseRemoval();
        this.showAdminLicenseRemovalConfirm = false;
    }

    async confirmAdminLicenseRemoval(): Promise<void> {
        const quantity = this.adminLicenseRemovalQuantity;
        if (quantity <= 0) {
            return;
        }

        if (!this.validateAdminLicenseDialogInput()) {
            return;
        }

        this.adminLicenseConfirmLoading = true;
        this.adminLicenseConfirmError = null;

        try {
            const subscriptionIds =
                this.getAdditionalAdminSubscriptionIdsToCancel(
                    quantity,
                    this.adminLicenseRemovalType
                );

            if (subscriptionIds.length < quantity) {
                throw new Error(
                    `Only found ${subscriptionIds.length} Additional Admin subscription${subscriptionIds.length === 1 ? '' : 's'} on file to cancel.`
                );
            }

            for (const subscriptionId of subscriptionIds) {
                await this.authorizeNetCheckoutService
                    .cancelSubscription(subscriptionId)
                    .pipe(take(1))
                    .toPromise();
            }

            if (this.customerId) {
                try {
                    const persistResponse = await this.authorizeNetCheckoutService
                        .recordAdminLicenseRemoval(
                            this.customerId,
                            quantity,
                            this.getCompanyEmailAddrToPersist(),
                            this.getEmailForCloudLoginToPersist(),
                            subscriptionIds
                        )
                        .pipe(take(1))
                        .toPromise();
                    this.applyPersistedCompanyInfoLicenseUpdates({
                        adminCount: persistResponse?.adminCount,
                        activePurchaseCount: persistResponse?.activePurchaseCount
                    });
                } catch {
                    // Subscriptions were canceled; company info persistence is best-effort.
                }
            }

            this.licensedAdminCount = this.targetLicensedAdminCount;
            this.adminLicensePreviewMessage =
                `Canceled ${subscriptionIds.length} administrator subscription${subscriptionIds.length === 1 ? '' : 's'}.`;
            this.closeAdminLicenseConfirmDialogAfterSuccess();
        } catch (err) {
            this.adminLicenseConfirmError = this.getAuthorizeNetErrorMessage(err);
        } finally {
            this.adminLicenseConfirmLoading = false;
        }
    }

    resetTargetLicensedAdminCount(): void {
        this.targetLicensedAdminCount = this.licensedAdminCount;
        this.adminLicensePreviewMessage = null;
    }

    private loadAdministratorInfo(): void {
        this.loadingAdminInfo = true;
        this.companyInfoLoadFailed = false;
        this.store
            .pipe(
                select(fromAuth.getAuth),
                filter(auth => !!auth?.CustomerID),
                take(1),
                switchMap(auth =>
                    forkJoin({
                        companyInfo: this.customerAdminService
                            .get(auth.CustomerID, false)
                            .pipe(
                                map(resp => {
                                    const items = JSON.parse(
                                        resp
                                    ) as CompanyInfo[];
                                    return {
                                        data:
                                            items?.length > 0 ? items[0] : null,
                                        loadFailed: false
                                    };
                                }),
                                catchError(() =>
                                    of({ data: null as CompanyInfo | null, loadFailed: true })
                                )
                            ),
                        assigned: this.groupsService
                            .postGroupMember({ GroupID: 1 })
                            .pipe(
                                map((members: Array<IGroupMember>) => {
                                    const isAssigned = (m: IGroupMember) =>
                                        m.IsGroupMember === true ||
                                        (m as { IsGroupMember?: unknown })
                                            .IsGroupMember === 1;
                                    const isCertifiedAdvisor = (
                                        m: IGroupMember
                                    ) =>
                                        m.IsAdvisorAdmin === true ||
                                        (m as { IsAdvisorAdmin?: unknown })
                                            .IsAdvisorAdmin === 1;
                                    const assignedMembers =
                                        members.filter(isAssigned);
                                    return {
                                        // Licensed slots exclude certified advisors.
                                        assignedAdminCount:
                                            assignedMembers.filter(
                                                m => !isCertifiedAdvisor(m)
                                            ).length,
                                        advisorAdminCount: members.filter(
                                            isCertifiedAdvisor
                                        ).length,
                                        assignedAdvisorAdminCount:
                                            assignedMembers.filter(
                                                isCertifiedAdvisor
                                            ).length
                                    };
                                }),
                                catchError(() =>
                                    of({
                                        assignedAdminCount: 0,
                                        advisorAdminCount: 0,
                                        assignedAdvisorAdminCount: 0
                                    })
                                )
                            ),
                        customerId: of(auth.CustomerID)
                    })
                ),
                takeWhile(() => this.active)
            )
            .subscribe({
                next: ({ companyInfo, assigned, customerId }) => {
                    this.customerId =
                        customerId != null ? String(customerId) : null;
                    this.companyInfoLoadFailed = companyInfo.loadFailed;
                    this.companyInfo = companyInfo.loadFailed ? null : companyInfo.data;
                    this.showCloudLoginOption =
                        companyInfo.data?.HostProviderID ===
                        this.cloudLoginHostProviderId;
                    this.licensedAdminCount = companyInfo.data?.AdminCount ?? 1;
                    this.customerProfileId =
                        companyInfo.data?.CustomerProfileID != null
                            ? String(companyInfo.data.CustomerProfileID)
                            : null;
                    this.assignedAdminCount = assigned.assignedAdminCount;
                    this.advisorAdminCount = assigned.advisorAdminCount;
                    this.assignedAdvisorAdminCount =
                        assigned.assignedAdvisorAdminCount;
                    this.targetLicensedAdminCount = this.licensedAdminCount;
                    this.loadingAdminInfo = false;
                },
                error: () => {
                    this.companyInfoLoadFailed = true;
                    this.companyInfo = null;
                    this.loadingAdminInfo = false;
                }
            });
    }

    private loadAcceptUiScript(): void {
        if (document.getElementById('authorize-net-accept-ui-script')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'authorize-net-accept-ui-script';
        script.src = environment.authorizeNet.acceptUiScriptUrl;
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        document.body.appendChild(script);
    }

    private registerAdminLicenseAcceptUiHandler(): void {
        (window as { __efAdminLicenseAcceptUiCallback?: (response: unknown) => void })
            .__efAdminLicenseAcceptUiCallback = (response: unknown) => {
            this.ngZone.run(() => this.onAdminLicenseAcceptUiResponse(response));
        };
    }

    private onAdminLicenseAcceptUiResponse(response: unknown): void {
        const acceptUiResponse = response as {
            messages?: {
                resultCode?: string;
                message?: Array<{ text?: string }>;
            };
            opaqueData?: {
                dataDescriptor?: string;
                dataValue?: string;
            };
        };

        if (acceptUiResponse.messages?.resultCode === 'Error') {
            const messages = acceptUiResponse.messages.message ?? [];
            this.adminLicenseConfirmError = messages
                .map(item => item.text)
                .filter(Boolean)
                .join(' ');
            return;
        }

        const opaqueData = acceptUiResponse.opaqueData;
        if (!opaqueData?.dataDescriptor || !opaqueData?.dataValue) {
            this.adminLicenseConfirmError =
                'No payment data was received from Authorize.Net.';
            return;
        }

        if (this.adminLicensePaymentInFlight) {
            return;
        }

        void this.submitAdminLicensePayment({
            dataDescriptor: opaqueData.dataDescriptor,
            dataValue: opaqueData.dataValue
        });
    }

    private async submitAdminLicensePayment(opaqueData: {
        dataDescriptor: string;
        dataValue: string;
    }): Promise<void> {
        const quantity = this.adminLicenseOrderQuantity;
        if (!this.customerId) {
            this.adminLicenseConfirmError =
                'Customer ID is not available. Sign in again and retry.';
            return;
        }
        if (quantity <= 0) {
            this.adminLicenseConfirmError =
                'No administrator licenses selected to purchase.';
            return;
        }

        if (this.adminLicensePaymentInFlight) {
            return;
        }

        this.adminLicensePaymentInFlight = true;
        this.adminLicenseConfirmLoading = true;
        this.adminLicenseConfirmError = null;

        try {
            const response = await this.authorizeNetCheckoutService
                .createSubscriptionsFromPayment({
                    dataDescriptor: opaqueData.dataDescriptor,
                    dataValue: opaqueData.dataValue,
                    merchantCustomerId: this.customerId,
                    quantity,
                    unitAmount: this.additionalAdminUnitPrice,
                    subscriptionNamePrefix: this.additionalAdminProductName,
                    emailAddr: this.getCompanyEmailAddrToPersist(),
                    emailForCloudLogin: this.getEmailForCloudLoginToPersist(),
                    companyName: this.companyInfo?.Name,
                    address1: this.companyInfo?.Address1,
                    address2: this.companyInfo?.Address2,
                    address3: this.companyInfo?.Address3,
                    city: this.companyInfo?.City,
                    state: this.companyInfo?.State,
                    zipCode: this.companyInfo?.ZipCode,
                    includeRightworksAccess: this.shouldIncludeRightworksAccess(),
                    rightworksUnitAmount: this.rightworksAccessUnitPrice,
                    rightworksQuantity: this.rightworksAccessOrderQuantity,
                    rightworksSubscriptionNamePrefix: this.rightworksAccessProductName
                })
                .pipe(take(1))
                .toPromise();

            if (response?.customerProfileId != null) {
                this.customerProfileId = String(response.customerProfileId);
            }

            const adminSubscriptionIds = response?.subscriptionIds?.map(String) ?? [];
            const rightworksSubscriptionIds =
                response?.rightworksSubscriptionIds?.map(String) ?? [];

            this.applyPersistedCompanyInfoLicenseUpdates({
                customerProfileId: response?.customerProfileId,
                adminCount: response?.adminCount,
                activePurchaseCount: response?.activePurchaseCount,
                subscriptionId:
                    response?.subscriptionId ?? adminSubscriptionIds[0],
                subscriptionIds: adminSubscriptionIds,
                rightworksSubscriptionIds,
                emailForCloudLogin: this.getEmailForCloudLoginToPersist()
            });

            const subscriptionCount =
                adminSubscriptionIds.length + rightworksSubscriptionIds.length;
            this.licensedAdminCount =
                response?.adminCount ?? this.targetLicensedAdminCount;
            this.adminLicensePreviewMessage =
                `Payment processed and ${subscriptionCount} subscription${subscriptionCount === 1 ? '' : 's'} created` +
                (rightworksSubscriptionIds.length > 0
                    ? ` (${adminSubscriptionIds.length} administrator and ${rightworksSubscriptionIds.length} RightWorks Access).`
                    : ` (${adminSubscriptionIds.length} administrator).`);
            this.closeAdminLicenseConfirmDialogAfterSuccess();
        } catch (err) {
            this.adminLicenseConfirmError = this.getAuthorizeNetErrorMessage(err);
        } finally {
            this.adminLicensePaymentInFlight = false;
            this.adminLicenseConfirmLoading = false;
        }
    }

    onAddToCartClicked(product) {
        this.showCart = true;
        this.selectedProducts.push(product);
    }

    removeFromCartClicked(product) {
        const index = this.selectedProducts.findIndex(x => x == product);
        this.selectedProducts.splice(index, 1);

        if (this.selectedProducts.length == 0) {
            this.showCart = false;
        } else {
            this.showCart = true;
        }
    }

    layoutOptionsChanged($event) {
        if ($event.value == 'list') {
            this.layout = 'list';
        }
        if ($event.value == 'grid') {
            this.layout = 'grid';
        }
    }

    addQuantity(product) {
        product.quantity = (+product.quantity + 1).toString();
    }
    subtractQuantity(product) {
        product.quantity = (+product.quantity - 1).toString();
    }

    buyButtonClicked(product) {
        this.paymentFormId = 'paymentForm' + '-' + product.id;
    }

    private async loadCustomerProfileIds(): Promise<{
        customerProfileId: string;
        customerPaymentProfileId: string;
        customerAddressId: string;
    }> {
        if (!this.customerProfileId) {
            throw new Error(
                'Customer profile ID is not available. Contact support if this problem persists.'
            );
        }

        const profileResponse = await this.authorizeNetCheckoutService
            .getCustomerProfile({
                customerProfileId: this.customerProfileId,
                unmaskExpirationDate: true
            })
            .pipe(take(1))
            .toPromise();

        if (!profileResponse) {
            throw new Error('No response received from Authorize.Net customer profile lookup.');
        }

        return this.extractCustomerProfileIds(profileResponse);
    }

    private async refreshPaymentMethodOnFileForDialog(
        refreshGeneration = this.paymentMethodRefreshGeneration
    ): Promise<void> {
        if (this.needsAdminLicensePaymentSetup || !this.customerProfileId) {
            if (refreshGeneration === this.paymentMethodRefreshGeneration) {
                this.clearPaymentMethodOnFileDisplay();
            }
            return;
        }

        if (refreshGeneration === this.paymentMethodRefreshGeneration) {
            this.loadingPaymentMethodOnFile = true;
            this.paymentMethodOnFileDisplay = null;
        }

        try {
            const profileResponse = await this.authorizeNetCheckoutService
                .getCustomerProfile({
                    customerProfileId: this.customerProfileId,
                    includeIssuerInfo: true,
                    unmaskExpirationDate: true
                })
                .pipe(take(1))
                .toPromise();

            if (refreshGeneration !== this.paymentMethodRefreshGeneration) {
                return;
            }

            this.paymentMethodOnFileDisplay =
                (profileResponse
                    ? this.extractPaymentMethodDisplay(profileResponse)
                    : null) ??
                (await this.lookupPaymentMethodFromSubscriptions());

            if (refreshGeneration !== this.paymentMethodRefreshGeneration) {
                return;
            }
        } catch {
            if (refreshGeneration !== this.paymentMethodRefreshGeneration) {
                return;
            }

            const fallbackDisplay =
                await this.lookupPaymentMethodFromSubscriptions();
            if (refreshGeneration !== this.paymentMethodRefreshGeneration) {
                return;
            }

            this.paymentMethodOnFileDisplay = fallbackDisplay;
        } finally {
            if (refreshGeneration === this.paymentMethodRefreshGeneration) {
                this.loadingPaymentMethodOnFile = false;
            }
        }
    }

    private async lookupPaymentMethodFromSubscriptions(): Promise<string | null> {
        if (!this.customerProfileId) {
            return null;
        }

        const profileId = String(this.customerProfileId).trim();
        const searchTypes = ['subscriptionActive', 'subscriptionInactive'] as const;

        for (const searchType of searchTypes) {
            try {
                const response = await this.authorizeNetCheckoutService
                    .getSubscriptions({
                        searchType,
                        orderBy: 'id',
                        orderDescending: true,
                        limit: 1000,
                        offset: 1
                    })
                    .pipe(take(1))
                    .toPromise();

                const match = (response?.subscriptionDetails ?? []).find(
                    subscription =>
                        String(subscription.customerProfileId ?? '').trim() ===
                            profileId &&
                        !!subscription.accountNumber?.trim()
                );

                if (match?.accountNumber) {
                    return this.formatSubscriptionAccountNumber(match);
                }
            } catch {
                // Try the next search type.
            }
        }

        return null;
    }

    private formatSubscriptionAccountNumber(subscription: {
        accountNumber?: string;
        paymentMethod?: string;
    }): string {
        const accountNumber = subscription.accountNumber?.trim() ?? '';
        const paymentMethod = subscription.paymentMethod?.trim();
        if (!accountNumber) {
            return '';
        }

        if (
            paymentMethod &&
            !accountNumber.toLowerCase().includes(paymentMethod.toLowerCase())
        ) {
            return `${paymentMethod} ${accountNumber}`;
        }

        return accountNumber;
    }

    private readRecordValue(
        record: Record<string, unknown> | undefined,
        key: string
    ): unknown {
        if (!record) {
            return undefined;
        }

        if (record[key] !== undefined) {
            return record[key];
        }

        const match = Object.keys(record).find(
            property => property.toLowerCase() === key.toLowerCase()
        );
        return match ? record[match] : undefined;
    }

    private collectPaymentProfiles(
        response: AuthorizeNetCustomerProfileResponse
    ): Array<Record<string, unknown>> {
        const root = response as unknown as Record<string, unknown>;
        const profile = (response.profile ??
            this.readRecordValue(root, 'profile')) as
            | Record<string, unknown>
            | undefined;
        const candidates = [
            this.readRecordValue(profile, 'paymentProfiles'),
            this.readRecordValue(profile, 'paymentProfile'),
            this.readRecordValue(root, 'paymentProfiles'),
            this.readRecordValue(root, 'paymentProfile')
        ];

        const profiles: Array<Record<string, unknown>> = [];
        for (const candidate of candidates) {
            if (Array.isArray(candidate)) {
                for (const entry of candidate) {
                    if (entry && typeof entry === 'object') {
                        profiles.push(entry as Record<string, unknown>);
                    }
                }
            } else if (candidate && typeof candidate === 'object') {
                profiles.push(candidate as Record<string, unknown>);
            }
        }

        return profiles;
    }

    private getPrimaryPaymentProfile(
        response: AuthorizeNetCustomerProfileResponse
    ): Record<string, unknown> | undefined {
        const profiles = this.collectPaymentProfiles(response);
        if (profiles.length === 0) {
            return undefined;
        }

        const profilesWithExpiration = profiles.filter(
            profile => this.getPaymentProfileExpirationEnd(profile) != null
        );
        if (profilesWithExpiration.length > 0) {
            const notExpired = profilesWithExpiration.filter(profile =>
                this.isPaymentProfileNotExpired(profile)
            );
            if (notExpired.length === 0) {
                return undefined;
            }

            return notExpired.sort((left, right) => {
                const leftExpiration =
                    this.getPaymentProfileExpirationEnd(left)?.getTime() ?? 0;
                const rightExpiration =
                    this.getPaymentProfileExpirationEnd(right)?.getTime() ?? 0;
                return rightExpiration - leftExpiration;
            })[0];
        }

        return (
            profiles.find(profile =>
                this.extractPaymentMethodFromProfileRecord(profile)
            ) ??
            profiles.find(profile =>
                this.readRecordValue(profile, 'customerPaymentProfileId')
            ) ??
            profiles[0]
        );
    }

    private getPaymentProfileExpirationEnd(
        paymentProfile: Record<string, unknown>
    ): Date | null {
        const payment = this.readRecordValue(paymentProfile, 'payment') as
            | Record<string, unknown>
            | undefined;
        const creditCard = this.extractCreditCardRecord(payment);
        const expirationDate = this.readRecordValue(creditCard, 'expirationDate');
        if (!expirationDate) {
            return null;
        }

        const match = /^(\d{4})-(\d{2})$/.exec(String(expirationDate).trim());
        if (!match) {
            return null;
        }

        const year = Number(match[1]);
        const month = Number(match[2]);
        if (month < 1 || month > 12) {
            return null;
        }

        return new Date(year, month, 0);
    }

    private isPaymentProfileNotExpired(
        paymentProfile: Record<string, unknown>
    ): boolean {
        const expirationEnd = this.getPaymentProfileExpirationEnd(paymentProfile);
        if (!expirationEnd) {
            return true;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return expirationEnd >= today;
    }

    private extractCreditCardRecord(
        payment: Record<string, unknown> | undefined
    ): Record<string, unknown> | undefined {
        const creditCard = this.readRecordValue(payment, 'creditCard');
        if (creditCard && typeof creditCard === 'object') {
            return creditCard as Record<string, unknown>;
        }

        const item = this.readRecordValue(payment, 'Item');
        if (item && typeof item === 'object') {
            return item as Record<string, unknown>;
        }

        return undefined;
    }

    private extractPaymentMethodFromProfileRecord(
        paymentProfile: Record<string, unknown>
    ): string | null {
        const payment = this.readRecordValue(paymentProfile, 'payment') as
            | Record<string, unknown>
            | undefined;
        const creditCard = this.extractCreditCardRecord(payment);
        const cardNumber = this.readRecordValue(creditCard, 'cardNumber');
        if (cardNumber) {
            const cardNumberText = String(cardNumber).trim();
            const cardType = this.readRecordValue(creditCard, 'cardType');
            const cardTypeText = cardType ? String(cardType).trim() : '';
            return cardTypeText
                ? `${cardTypeText} ${cardNumberText}`
                : cardNumberText;
        }

        const bankAccount = this.readRecordValue(payment, 'bankAccount') as
            | Record<string, unknown>
            | undefined;
        const accountNumber = this.readRecordValue(bankAccount, 'accountNumber');
        if (accountNumber) {
            const accountNumberText = String(accountNumber).trim();
            const accountType = this.readRecordValue(bankAccount, 'accountType');
            const accountTypeText = accountType
                ? String(accountType).trim()
                : 'Bank account';
            return `${accountTypeText} ${accountNumberText}`;
        }

        return null;
    }

    private extractPaymentMethodDisplay(
        response: AuthorizeNetCustomerProfileResponse
    ): string | null {
        const paymentProfile = this.getPrimaryPaymentProfile(response);
        if (!paymentProfile) {
            return null;
        }

        return this.extractPaymentMethodFromProfileRecord(paymentProfile);
    }

    private extractCustomerProfileIds(response: AuthorizeNetCustomerProfileResponse): {
        customerProfileId: string;
        customerPaymentProfileId: string;
        customerAddressId: string;
    } {
        const profile = response.profile as Record<string, unknown> | undefined;
        const customerProfileId =
            profile?.['customerProfileId'] ?? this.customerProfileId;
        const paymentProfile = this.getPrimaryPaymentProfile(response);
        if (!paymentProfile) {
            throw new Error(
                'No valid payment profile found on file. All cards may be expired; update payment information and try again.'
            );
        }
        const shipToList =
            this.readRecordValue(profile, 'shipToList') ??
            this.readRecordValue(profile, 'shipTo');
        const shipTo = Array.isArray(shipToList)
            ? (shipToList[0] as Record<string, unknown> | undefined)
            : (shipToList as Record<string, unknown> | undefined);

        const customerPaymentProfileId = this.readRecordValue(
            paymentProfile,
            'customerPaymentProfileId'
        );
        const customerAddressId = this.readRecordValue(shipTo, 'customerAddressId');

        if (
            customerProfileId == null ||
            customerPaymentProfileId == null ||
            customerAddressId == null
        ) {
            throw new Error(
                'Unable to resolve Authorize.Net customer profile, payment profile, and address IDs.'
            );
        }

        return {
            customerProfileId: String(customerProfileId),
            customerPaymentProfileId: String(customerPaymentProfileId),
            customerAddressId: String(customerAddressId)
        };
    }

    private buildProductSubscriptionName(
        productName: string,
        licenseIndex: number
    ): string {
        const customerId = String(this.customerId ?? '0').trim();
        const prefix = productName;
        const name = `${prefix}|${customerId}|${Date.now()}|${licenseIndex + 1}`;
        if (name.length <= 50) {
            return name;
        }

        const customerSuffix =
            customerId.length > 8 ? customerId.slice(-8) : customerId;
        return `${prefix}|${customerSuffix}|${Date.now()}|${licenseIndex + 1}`.slice(
            0,
            50
        );
    }

    private buildAdditionalAdminSubscriptionName(licenseIndex: number): string {
        return this.buildProductSubscriptionName(
            this.additionalAdminProductName,
            licenseIndex
        );
    }

    private isAdditionalAdminProductId(productId: number): boolean {
        return (
            productId === this.additionalAdminProductId ||
            productId === this.additionalAdminAnnualProductId
        );
    }

    private getActiveAdminPurchases(): Purchase[] {
        return (this.companyInfo?.Purchases ?? []).filter(
            purchase =>
                this.isAdditionalAdminProductId(purchase.ProductID) &&
                purchase.ProductName?.includes(this.additionalAdminProductName) &&
                purchase.SubscriptionID != null &&
                String(purchase.SubscriptionID).trim().length > 0 &&
                purchase.IsCancel !== true
        );
    }

    private isAnnualAdminPurchase(purchase: Purchase): boolean {
        return (purchase.Subscription ?? '').trim().toUpperCase() === 'A';
    }

    public get adminAnnualSubscriptionCount(): number {
        return this.getActiveAdminPurchases().filter(purchase =>
            this.isAnnualAdminPurchase(purchase)
        ).length;
    }

    public get adminMonthlySubscriptionCount(): number {
        return this.getActiveAdminPurchases().filter(
            purchase => !this.isAnnualAdminPurchase(purchase)
        ).length;
    }

    public get hasAnnualAdminSubscriptions(): boolean {
        return this.adminAnnualSubscriptionCount > 0;
    }

    /** True when the chosen cadence has fewer subscriptions than the quantity being removed. */
    public get adminLicenseRemovalWillMix(): boolean {
        if (!this.adminLicenseRemovalType) {
            return false;
        }
        const available =
            this.adminLicenseRemovalType === 'A'
                ? this.adminAnnualSubscriptionCount
                : this.adminMonthlySubscriptionCount;
        return this.adminLicenseRemovalQuantity > available;
    }

    public get adminLicenseRemovalMixMessage(): string {
        const quantity = this.adminLicenseRemovalQuantity;
        return (
            `By removing ${quantity} subscription${quantity === 1 ? '' : 's'} ` +
            `you will be removing a mix of annual and monthly subscriptions.`
        );
    }

    private getAdditionalAdminSubscriptionIdsToCancel(
        count: number,
        type: 'A' | 'M' | null = null
    ): string[] {
        const ordered = [...this.getActiveAdminPurchases()].reverse();

        if (!type) {
            return ordered
                .slice(0, count)
                .map(purchase => String(purchase.SubscriptionID));
        }

        const matchesType = (purchase: Purchase) =>
            type === 'A'
                ? this.isAnnualAdminPurchase(purchase)
                : !this.isAnnualAdminPurchase(purchase);

        const preferred = ordered.filter(matchesType);
        const remainder = ordered.filter(purchase => !matchesType(purchase));

        return [...preferred, ...remainder]
            .slice(0, count)
            .map(purchase => String(purchase.SubscriptionID));
    }

    private getSubscriptionStartDate(): string {
        return new Date().toLocaleDateString('en-CA');
    }

    private applyPersistedCompanyInfoLicenseUpdates(updates: {
        customerProfileId?: string | number | null;
        subscriptionId?: string | number | null;
        subscriptionIds?: string[];
        rightworksSubscriptionIds?: string[];
        adminCount?: number | null;
        activePurchaseCount?: number | null;
        emailForCloudLogin?: string | null;
    }): void {
        if (updates.customerProfileId != null) {
            this.customerProfileId = String(updates.customerProfileId);
        }

        if (updates.adminCount != null) {
            this.licensedAdminCount = updates.adminCount;
        }

        if (!this.companyInfo) {
            return;
        }

        const subscriptionIds =
            updates.subscriptionIds ??
            (updates.subscriptionId != null ? [String(updates.subscriptionId)] : []);
        const rightworksSubscriptionIds = updates.rightworksSubscriptionIds ?? [];
        const emailForCloudLogin = updates.emailForCloudLogin?.trim() || undefined;
        let purchases = this.appendProductPurchases(
            this.companyInfo.Purchases ?? [],
            subscriptionIds,
            this.additionalAdminProductName,
            this.additionalAdminProductId,
            this.additionalAdminBillingPeriod
        );
        purchases = this.appendProductPurchases(
            purchases,
            rightworksSubscriptionIds,
            this.rightworksAccessProductName,
            this.rightworksAccessProductId,
            this.rightworksAccessBillingPeriod,
            emailForCloudLogin
        );

        this.companyInfo = {
            ...this.companyInfo,
            ...(updates.customerProfileId != null
                ? { CustomerProfileID: updates.customerProfileId }
                : {}),
            ...(updates.subscriptionId != null
                ? { SubscriptionID: updates.subscriptionId }
                : {}),
            ...(updates.adminCount != null ? { AdminCount: updates.adminCount } : {}),
            ...(updates.activePurchaseCount != null
                ? { ActivePurchaseCount: updates.activePurchaseCount }
                : {}),
            ...(emailForCloudLogin
                ? { EmailForCloudLogin: emailForCloudLogin }
                : {}),
            ...(subscriptionIds.length > 0 || rightworksSubscriptionIds.length > 0
                ? { Purchases: purchases }
                : {})
        };
    }

    private appendProductPurchases(
        purchases: Purchase[],
        subscriptionIds: string[],
        productName: string,
        productId: number,
        billingPeriod: 'Monthly' | 'Annual',
        emailForCloudLogin?: string
    ): Purchase[] {
        if (subscriptionIds.length === 0) {
            return purchases;
        }

        const nextPurchases = [...purchases];
        const purchaseDate = new Date().toLocaleDateString('en-CA');
        const maintPaidDate = purchaseDate;
        const maintPaidThruDate = this.getMaintPaidThruDate(
            purchaseDate,
            billingPeriod
        );
        const trimmedCloudLoginEmail = emailForCloudLogin?.trim() || undefined;

        for (const subscriptionId of subscriptionIds) {
            if (
                nextPurchases.some(
                    purchase => String(purchase.SubscriptionID) === subscriptionId
                )
            ) {
                continue;
            }

            const purchase: Purchase = {
                SubscriptionID: subscriptionId,
                ProductName: productName,
                ProductDesc: productName,
                ProductID: productId,
                PurchaseDate: purchaseDate,
                MaintPaidDate: maintPaidDate,
                MaintPaidThruDate: maintPaidThruDate,
                EID: 0,
                Quantity: 1,
                ...(trimmedCloudLoginEmail
                    ? { EmailForCloudLogin: trimmedCloudLoginEmail }
                    : {})
            };

            nextPurchases.push(purchase);
        }

        return nextPurchases;
    }

    private appendAdditionalAdminPurchases(
        purchases: Purchase[],
        subscriptionIds: string[]
    ): Purchase[] {
        return this.appendProductPurchases(
            purchases,
            subscriptionIds,
            this.additionalAdminProductName,
            this.additionalAdminProductId,
            this.additionalAdminBillingPeriod
        );
    }

    private getMaintPaidThruDate(
        purchaseDate: string,
        billingPeriod: 'Monthly' | 'Annual'
    ): string {
        const paidThru = new Date(`${purchaseDate}T00:00:00`);
        if (billingPeriod === 'Annual') {
            paidThru.setFullYear(paidThru.getFullYear() + 1);
        } else {
            paidThru.setMonth(paidThru.getMonth() + 1);
        }
        paidThru.setDate(paidThru.getDate() - 1);

        return paidThru.toLocaleDateString('en-CA');
    }

    private getAdditionalAdminMaintPaidThruDate(purchaseDate: string): string {
        return this.getMaintPaidThruDate(
            purchaseDate,
            this.additionalAdminBillingPeriod
        );
    }

    private getAuthorizeNetErrorMessage(err: {
        status?: number;
        error?: unknown;
        message?: string;
    }): string {
        if (err?.status === 0) {
            return 'Unable to reach the Authorize.Net API. Rebuild and restart the service, then try again.';
        }

        const body = err?.error as {
            Message?: string;
            messages?: { message?: Array<{ text?: string }> | { text?: string } };
        };

        if (typeof body === 'string') {
            return body;
        }
        if (body?.Message) {
            return body.Message;
        }

        const message = body?.messages?.message;
        if (Array.isArray(message)) {
            return message.map(item => item.text).filter(Boolean).join(' ');
        }
        if (message && typeof message === 'object' && 'text' in message) {
            return String(message.text);
        }

        return err?.message ?? 'An unexpected error occurred while updating subscriptions.';
    }
}

export interface Product {
    name: string;
    category: string;
    price: string;
    image: string;
    quantity: string;
    id: string;
}
